import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-body-medium',
    templateUrl: './body-medium.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BodyMediumComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
